import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import sortUpImg from "../asserts/img/sortUp.svg";
import sortDownImg from "../asserts/img/sortDown.svg";

const Label = styled.label(() => ({
  fontSize: 13,
  fontWeight: 600,
}));

const SortLabel = ({ labelKey, label, width, handelSort, showImg, config }) => {
  return (
    <div
      style={{
        width: width,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
        flex: 1,
      }}
    >
      <div>
        <Label>{label}</Label>
      </div>
      <div style={{ margin: "auto", textAlign: "end" }}>
        <button
          id="sort"
          onClick={() => handelSort(labelKey)}
          style={{
            border: 0,
            backgroundColor: "transparent",
            padding: 0,
          }}
        >
          {showImg !== false && (
            <img
              src={
                config?.key === labelKey && config?.direction === "descending"
                  ? sortUpImg
                  : sortDownImg
              }
              alt="sort"
              style={{ cursor: "pointer", height: 18, width: 20, marginTop: 4 }}
            />
          )}
        </button>
      </div>
    </div>
  );
};

const StyledBox = styled.div(({ fromTask }) => ({
  flexWrap: "wrap",
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  fontFamily: "Heebo, sans-serif",
  margin: !fromTask && "0 50px",
}));

const BoxContent = styled.div(({ width }) => ({
  width: width,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  background: "#F4F4F4",
  borderRadius: 7,
  height: 43,
  border: "2px solid #fff",
  paddingInlineStart: 9,
}));

const TableHeader = ({ keys, translation, handelSort, config, fromTask }) => {
  const { t } = useTranslation(translation);

  return (
    <>
      <StyledBox fromTask={fromTask}>
        <>
          {keys.map((key, index) => {
            return (
              <BoxContent width={key.width} key={`${key}${index}`}>
                {key.sort === true ? (
                  <SortLabel
                    labelKey={key.key}
                    config={config}
                    label={t(key.key)}
                    handelSort={handelSort}
                  />
                ) : (
                  <Label> {t(key.key)}</Label>
                )}
              </BoxContent>
            );
          })}
        </>
      </StyledBox>
    </>
  );
};

export default inject()(observer(TableHeader));
